<template>
  <div class="">
    <div class="h-20"></div>
    <div class="main" style="background-color: #fff; padding: 20px">
      <NewsIndex></NewsIndex>
    </div>
    <div class="h-20"></div>
    <div class="xuexi main" style="">
      <a :href="websitInfo.advert_url" target="_blank" tabindex="0">
        <img
          :src="websitInfo.advert_image | baseImg"
          style="width: 100%"
          alt=""
        />
      </a>
    </div>
    <div class="h-20"></div>
    <div class="main index-tabs">
      <div class="left">
        <IndexCard title="信息公开" to="/zhengwu">
          <div class="xinxigongkai-list">
            <router-link
              :to="{
                name: 'zhengwu_detail',
                query: {
                  id: item.id,
                  name: item.name,
                },
              }"
              class="item"
              v-for="item in xinxigongkaiList"
              :key="item.id"
              target="_blank"
            >
              <div class="tit z-line-1" :title="item.title">
                {{ item.title }}
              </div>
              <span class="time">{{ item.addtime | dayjs("year-date") }}</span>
            </router-link>
          </div>
        </IndexCard>
      </div>
      <div class="right">
        <router-link
          :to="{ name: 'hudong' }"
          title="互动交流"
          class="right-item"
          target="_blank"
        >
          <img
            src="images/index/hudongjiaoliu.png"
            alt="互动交流"
            class="img"
          />
        </router-link>
        <router-link
          :to="{ name: 'dafu' }"
          title="咨询答复"
          class="right-item"
          target="_blank"
        >
          <img src="images/index/zixundafu.png" alt="咨询答复" class="img" />
        </router-link>
        <router-link
          :to="{ name: 'zhengwu', query: { id: 16, name: '投诉举报' } }"
          title="投诉举报"
          class="right-item"
          target="_blank"
        >
          <img src="images/index/tousujubao.png" alt="投诉举报" class="img" />
        </router-link>
      </div>
    </div>
    <div class="h-20"></div>
    <div class="main">
      <!-- 专题专栏 -->
      <IndexTopic> </IndexTopic>
    </div>
    <div class="h-20"></div>
  </div>
</template>
<script>
import IndexCard from "./components/IndexCard.vue";
import IndexTopic from "./components/IndexTopic.vue";
import NewsIndex from "../news/index.vue";
//
import { mapState } from "vuex";
import { gm_article_list } from "@/apis/zhengwu";

export default {
  name: "Index",
  components: {
    NewsIndex,
    IndexCard,
    IndexTopic,
    // IndexLinks,
  },
  data() {
    return {
      xinxigongkaiList: [],
    };
  },

  computed: {
    ...mapState(["websitInfo"]),
  },
  created() {
    this.gm_article_list();
  },
  methods: {
    async gm_article_list() {
      const { data } = await gm_article_list({
        page: 1,
        pagenum: 5,
      });

      // this.total = data.total;
      // this.per_page = data.per_page;
      // this.current_page = data.current_page;
      this.xinxigongkaiList = data.data || [];
    },
  },
};
</script>

<style lang="scss">
.index-banner-wrap {
  display: flex;

  .index-card {
    flex: 1;
    .card-header {
      padding-left: 0;
      // padding-right: 0;
      padding-right: 20px;
    }
  }
}

.news-2 {
  display: flex;
  background-color: #fff;
  & > div {
    flex: 1;
    padding: 0 20px;
  }
}
.index-tabs {
  display: flex;
  .left {
    flex: 1;
    background-color: #fff;
  }
  .right {
    flex-shrink: 0;
    width: 340px + 20px;
    padding-left: 20px;
  }
  .right-item {
    display: block;
    width: 340px;
    height: 117px;
    margin-top: 20px;
    &:first-child {
      margin-top: 0;
    }
    .img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.xinxigongkai-list {
  padding: 10px;
  .item {
    // display: block;
    display: flex;
    height: 60px;
    line-height: 60px;
    position: relative;
    padding: 0 14px 0 30px;
    &:hover {
      background: #f2f6fc;
      .tit {
        color: #1e6af7;
      }
    }
    &::before {
      content: "";
      position: absolute;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #1e6af7;
      top: 50%;
      margin-top: -5px;
      left: 12px;
    }
    .tit {
      flex: 1;
      //
      font-size: 16px;
      font-size: var(--font-size-16);
      font-weight: 400;
      color: #333333;
    }
    .time {
      width: 10em;
      flex-shrink: 0;
      //
      width: 86px;
      font-size: 16px;
      font-size: var(--font-size-16);
      font-weight: 400;
      color: #999999;
    }
  }
}
</style>
<style scoped>
.fixed-left,
.fixed-right {
  /* top: 400px !important; */
  top: calc(100vh - 530px);
}
</style>